import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export function AuthCallback() {
  const { hash } = useLocation();
  const nav = useNavigate();
  const { googleLogin } = useAuth();
  const done = useRef(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    googleLogin(sid)
      .then((u) => nav(u.status === "active" && u.role === "admin" ? "/admin" : "/portal", { replace: true }))
      .catch((e) => setErr(errMsg(e)));
  }, [hash, googleLogin, nav]);

  return (
    <main className="grid min-h-screen place-items-center px-5" data-testid="auth-callback">
      {err ? (
        <div className="text-center">
          <p className="text-rose-400" data-testid="auth-callback-error">{err}</p>
          <a href="/login" className="btn-ghost mt-6">Back to sign in</a>
        </div>
      ) : (
        <Loader2 className="h-6 w-6 animate-spin text-sky-400" />
      )}
    </main>
  );
}
